(function () {
	'use strict';

	var module = angular.module('uwAgenda.agenda');

	// directive for agenda appointment
	module.directive('agendaAppointment', [
		'$rootScope',
		'$window',
		'$translate',
		'AppointmentRecurrenceUpdateService',
		'ProtocolBroadcastService',
		'ProtocolFilter',
		'AppointmentService',
		'SharedAgendaService',
		'HelperService',
		'ExportFormat',
		'Alert',
		'$uibModal',
		'AgendaOverviewService',
		'AgendaFilterBroadcast',
		'AppConfig',
		'$uibModalStack',
		'ConfirmationMessageType',
		'IntegratorTypeEnum',
		function ($rootScope,
							$window,
							$translate,
							AppointmentRecurrenceUpdateService,
							ProtocolBroadcastService,
							ProtocolFilter,
							AppointmentService,
							SharedAgendaService,
							HelperService,
							ExportFormat,
							Alert,
							$uibModal,
							AgendaOverviewService,
							AgendaFilterBroadcast,
							AppConfig,
							$uibModalStack,
							ConfirmationMessageType,
							IntegratorTypeEnum) {
			var directive = {
				restrict: 'E',
				templateUrl: '/app/agenda/templates/agenda-appointment.template.html',
				link: link,
				scope: {
					appointment: '='
				}
			};
			return directive;

			function link(scope, element, attrs) {
				var modalInstance = null;

				scope.isAllowedToSeeSensitiveInfo = $rootScope.isAllowedToSeeSensitiveInfo;

				loadLocation(scope.appointment.id);

				var agenda = SharedAgendaService.getAgenda(scope.appointment.fK_Agenda);
				scope.medirisIntegration = agenda.medirisIntegration;
				scope.isPartOfEyeFileIntegration = SharedAgendaService.currentUserIsPartOfEyeFileIntegration();
				
				scope.openPatientInMediris = function (event) {
					event.stopPropagation();
					var patient = scope.appointment.patient;
					var medirisUrl = HelperService.getMedirisUrl(
						patient.firstName,
						patient.lastName,
						patient.birthday
					);

					$window.open(medirisUrl, '_blank');
				};

				scope.openPatientInEyeFile = function (event) {
					event.stopPropagation();
					let patient = scope.appointment.patient;

					let url = null;
					if (scope.isPartOfEyeFileIntegration) {
						let externalFileId = undefined;
						if (patient.integrationsUsers && 
							patient.integrationsUsers.length > 0 &&
							patient.integrationsUsers[0]) {
							externalFileId = patient.integrationsUsers[0].externalFileId;
						}
						
						url = HelperService.getEyeFileUrlNew(
							patient.firstName,
							patient.lastName,
							patient.birthday,
							patient.mainMobileNumberInMachineFormat,
							patient.mainEmail,
							patient.uniqueId,
							externalFileId
						);
					}

					if (url != null) {
						$window.open(url, "_blank");
					}
				}

				// remove <rf-global-summernote> if readonly = true else content-readonly
				// if (attrs.readonly) {
				//     element.find("rf-global-summernote").remove();
				// } //if
				// else {
				//     element.find("#content-readonly").remove();
				// } // else

				// send confirmation message
				scope.sendReminderMessage = function () {
					sendReminderMessage([ConfirmationMessageType.Email.name]);
				};

				scope.sendReminderSmsMessage = function () {
					sendReminderMessage([ConfirmationMessageType.Sms.name]);
				};

				scope.sendReminderMessages = function () {
					sendReminderMessage([ConfirmationMessageType.Sms.name, ConfirmationMessageType.Email.name]);
				};

				/**
				 *
				 * @param types {string[]}
				 * @returns {void}
				 */
				function sendReminderMessage(types) {
					AppointmentService.sendReminderMessage(scope.appointment.id, types).then(function (result) {
						Alert.success($translate.instant('messages_scheduled'));
					});
				}

				scope.cancel = function () {
					if (scope.appointment.recurrence) {
						AppointmentRecurrenceUpdateService
							.getUpdateMethod()
							.then(function (recurrenceUpdate) {
								cancelAppointment(recurrenceUpdate);
							});
					} else {
						cancelAppointment();
					}
				};

				scope.hasContent = function () {
					if (scope.appointment && scope.appointment.content) {
						var cleanContent = HelperService.removeLineBreaksFromString(
							HelperService.htmlToPlainText(scope.appointment.content)
						);
						return cleanContent.length > 0;
					}
					return false;
				};

				function cancelAppointment(recurrenceUpdateMethod) {
					AppointmentService
						.showDeleteConfirmationModal(scope.appointment.id, recurrenceUpdateMethod)
						.then(function (result) {
							if (!result) {
								return;
							}

							// show protocol                        
							ProtocolBroadcastService.broadcast(ProtocolFilter.ShowOnAppointmentDelete);

							// inform listeners
							$rootScope.$broadcast(AgendaFilterBroadcast.ListRefresh, scope.appointment.fK_Agenda);

							$uibModalStack.dismissAll();
						});
				}

				// Go to Agenda-Day
				scope.goToAgenda = function () {
					// show agenda-day-view
					AgendaOverviewService.showAgendaPerDay(scope.appointment.appointmentDate);
				};

				// print information
				scope.showPrintModal = function (scope, appointmentId, agendaId) {
					// open printmodal
					AgendaOverviewService.showPrintModal(scope, appointmentId, agendaId);
				};

				// print
				scope.closePrintModalAndPrint = function (selectedLayout) {
					// close print modal and print
					AgendaOverviewService.closePrintModalAndPrint(selectedLayout);
				};

				function loadLocation(appointmentId) {
					AppointmentService.getInternalLocation(appointmentId)
						.then(function (location) {
							scope.location = location;
						});
				}
			}
		}]);

})();